import { render } from "./EditAccount.vue?vue&type=template&id=b7a29a0e"
import script from "./EditAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./EditAccount.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/EditAccount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b7a29a0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b7a29a0e', __exports__)) {
    api.reload('b7a29a0e', __exports__)
  }
  
  module.hot.accept("./EditAccount.vue?vue&type=template&id=b7a29a0e", () => {
    api.rerender('b7a29a0e', render)
  })

}


export default __exports__